import React, { useState, useContext } from "react";
import Layout from "../components/layout/Layout";
import {
  FormHelperText,
  FormControl,
  Select,
  MenuItem,
  Typography,
  Divider,
  Button,
  Box,
  Drawer,
  TextField,
  useTheme,
} from "@mui/material";
import InputsContext from "../context/InputContext";

const RecordAdd = () => {
  const { drawerState, toggleDrawer } = useContext(InputsContext);
  const [partyType, setPartyType] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [serialNumber, setSerialNumber] = useState("");

  const theme = useTheme();

  const handlePartyTypeChange = (event) => {
    setPartyType(event.target.value);
  };

  const handleTransactionTypeChange = (event) => {
    setTransactionType(event.target.value);
  };

  const handleSerialNumberChange = (event) => {
    setSerialNumber(event.target.value);
  };

  const preventPropagation = (event) => {
    event.stopPropagation();
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 350,
        padding: theme.spacing(3),
      }}
      role="presentation"
    >
      <Typography variant="h6" component="h2" gutterBottom>
        Record Transaction
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Exclusive optimizing neural-net
      </Typography>
      <Divider sx={{ mb: 3, borderColor: theme.palette.warning.main }} />

      {/* Party Type */}
      <FormControl
        fullWidth
        size="small"
        sx={{ mb: 2 }}
        onClick={preventPropagation}
        onKeyDown={preventPropagation}
      >
        <FormHelperText
          sx={{ mb: 0.5, fontWeight: theme.typography.fontWeightBold }}
        >
          Party Type:
        </FormHelperText>
        <Select
          value={partyType}
          onChange={handlePartyTypeChange}
          displayEmpty
          inputProps={{ "aria-label": "Select party type" }}
          sx={{ fontSize: theme.typography.body2.fontSize }}
        >
          <MenuItem value="">Select Party Type</MenuItem>
          <MenuItem value="Customer">Customer</MenuItem>
          <MenuItem value="Vendor">Vendor</MenuItem>
          <MenuItem value="Employee">Employee</MenuItem>
          <MenuItem value="Bank">Bank</MenuItem>
          <MenuItem value="Other">Other</MenuItem>
        </Select>
      </FormControl>

      {/* Party Name */}
      <FormHelperText
        sx={{ mb: 0.5, fontWeight: theme.typography.fontWeightBold }}
      >
        Party Name:
      </FormHelperText>
      <TextField
        fullWidth
        color="warning"
        focused
        multiline
        minRows={1}
        onClick={preventPropagation}
        onKeyDown={preventPropagation}
        sx={{
          mb: 2,
          "& .MuiInputBase-root": {
            padding: theme.spacing(1.5),
          },
        }}
      />

      {/* Transaction Type */}
      <FormControl
        fullWidth
        size="small"
        sx={{ mb: 2 }}
        onClick={preventPropagation}
        onKeyDown={preventPropagation}
      >
        <FormHelperText
          sx={{ mb: 0.5, fontWeight: theme.typography.fontWeightBold }}
        >
          Transaction type (optional):
        </FormHelperText>
        <Select
          value={transactionType}
          onChange={handleTransactionTypeChange}
          displayEmpty
          inputProps={{ "aria-label": "Select transaction type" }}
          sx={{ fontSize: theme.typography.body2.fontSize }}
        >
          <MenuItem value="">Select Transaction Type</MenuItem>
          <MenuItem value="Sale">Sale</MenuItem>
          <MenuItem value="Purchase">Purchase</MenuItem>
          <MenuItem value="Payment_Received">Payment Received</MenuItem>
          <MenuItem value="Payment_Made">Payment Made</MenuItem>
          <MenuItem value="Return">Return</MenuItem>
          <MenuItem value="Expense">Expense</MenuItem>
        </Select>
      </FormControl>

      {/* Serial Number (Optional) */}
      <FormControl
        fullWidth
        size="small"
        sx={{ mb: 2 }}
        onClick={preventPropagation}
        onKeyDown={preventPropagation}
      >
        <FormHelperText
          sx={{ mb: 0.5, fontWeight: theme.typography.fontWeightBold }}
        >
          Serial Number (optional):
        </FormHelperText>
        <Select
          value={serialNumber}
          onChange={handleSerialNumberChange}
          displayEmpty
          inputProps={{ "aria-label": "Select serial number" }}
          sx={{ fontSize: theme.typography.body2.fontSize }}
        >
          <MenuItem value="">Select or Enter Serial Number</MenuItem>
          <MenuItem value="SN12345">SN12345</MenuItem>
          <MenuItem value="SN67890">SN67890</MenuItem>
          <MenuItem value="SNABCDE">SNABCDE</MenuItem>
          <MenuItem value="SNFGHIJ">SNFGHIJ</MenuItem>
        </Select>
      </FormControl>

      {/* Description (Optional) */}
      <FormHelperText
        sx={{ mb: 0.5, fontWeight: theme.typography.fontWeightBold }}
      >
        Description (optional):
      </FormHelperText>
      <TextField
        fullWidth
        color="warning"
        focused
        multiline
        minRows={3}
        onClick={preventPropagation}
        onKeyDown={preventPropagation}
        sx={{
          mb: 3,
          "& .MuiInputBase-root": {
            padding: theme.spacing(1.5),
          },
        }}
      />

      <Divider sx={{ mb: 3, borderColor: theme.palette.warning.main }} />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={toggleDrawer(anchor, false)}
          sx={{ mr: 2 }}
        >
          Cancel
        </Button>
        <Button variant="contained" color="primary">
          Submit
        </Button>
      </Box>
    </Box>
  );

  return (
    <Layout>
      <Button
        onClick={toggleDrawer("right", true)}
        variant="contained"
        color="primary"
      >
        Open Record Transaction
      </Button>
      <Drawer
        anchor="right"
        open={drawerState.right}
        onClose={toggleDrawer("right", false)}
        sx={{
          "& .MuiDrawer-paper": {
            borderLeft: `2px solid ${theme.palette.error.main}`,

            borderRadius: "16px 0 0 16px",
            boxShadow: theme.shadows[7],
          },
        }}
      >
        {list("right")}
      </Drawer>
    </Layout>
  );
};

export default RecordAdd;
